<template>
  <div class="dropdown is-right" :class="{ 'is-active': active }" @click="active = !active">
    <div class="dropdown-trigger">
      <button class="button is-black is-uppercase" aria-haspopup="true" aria-controls="dropdown-menu">
        <span>{{ $t(label) }}</span>
        <span class="icon is-small">
          <i class="material-icons">&#xE5C5;</i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
          <a v-for="(item, index) in ranges"
             :key="index"
             class="dropdown-item"
             :class="{ 'is-active': isActive(item) }"
             @click="setRange(item.from, item.to);"
          >
            {{ $t(item.label) }}
          </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getTimeRange } from 'utils/time';
import { find } from 'lodash/fp';
import store from '@/store';
import router from '@/router';
import Dropdown from 'views/mixins/dropdown'

export default {

  extends: Dropdown,

  data() {
    return {
      ranges: [
        {label: 'ui.time_ranges.last_7_days', ...getTimeRange(7)},
        {label: 'ui.time_ranges.last_14_days', ...getTimeRange(14)},
        {label: 'ui.time_ranges.last_30_days', ...getTimeRange(30)},
        {label: 'ui.time_ranges.last_60_days', ...getTimeRange(60)}
      ]
    }
  },

  computed: {

    timeRange () {
      return this.$store.getters['params/timeRange']
    },

    label() {
      const range = this.ranges.find(range => this.isActive(range))
      return range
        ? range.label
        : 'ui.time_ranges.custom';
    }
  },

  mounted() {
    let query = this.$route.query
    this.setRange(query.from, query.to)
  },

  methods: {
    setRange (from, to) {
      if (from && to) {
        if (from !== this.timeRange.from || to !== this.timeRange.to) {
          store.commit('params/timeRange', { from, to });
        }
      }
    },

    isActive(timeRange) {
      return String(this.timeRange.from) === String(timeRange.from) && String(this.timeRange.to) === String(timeRange.to);
    },
  },
  
  watch: {
    '$route.query'({from, to}) {
      this.setRange(from, to)
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.button,
.dropdown-menu {
  min-width: 14.875rem;
}

.button {
  line-height: 1.33;
  padding: .75rem 1.5rem;
  background-color: #0b031e;
}
</style>
